import { useMemo } from 'react';

export const useGlobalFilters = ({ impacted, globalFilters, dimensionsList }) => {
  const resGF = useMemo(() => {
    if (!impacted) {
      return globalFilters ?? [[]];
    }
    return (globalFilters ?? [[]]).map((group) =>
      group.map((item) => {
        const field = item.field;
        const fieldName = (dimensionsList as any).find((d) => d.field === field)?.name ?? field;
        return {
          ...item,
          fieldName,
        };
      }),
    );
  }, [dimensionsList, globalFilters, impacted]);

  return resGF;
};
